"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuestionMark = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var QuestionMark = function QuestionMark() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.31 2c2.708 0 4.904 2.182 4.904 4.873l.12.948a4.893 4.893 0 01-3.406 4.619l-1.618.524a.22.22 0 00-.204.204v1.32a.849.849 0 01-.852.845H10.96a.849.849 0 01-.851-.846v-1.32a3.183 3.183 0 012.196-3.011l1.618-.525a1.913 1.913 0 001.294-1.81v-.948a1.901 1.901 0 00-1.907-1.895H9.904c-.506 0-.99.2-1.348.555a1.889 1.889 0 00-.559 1.34v.846a.849.849 0 01-.851.846H5.85A.849.849 0 015 7.72v-.846C5 4.182 7.196 2 9.904 2h3.406zm-2.477 16.667H12.5c.46 0 .833.373.833.833v1.667c0 .46-.373.833-.833.833h-1.667a.833.833 0 01-.833-.833V19.5c0-.46.373-.833.833-.833z",
    clipRule: "evenodd"
  });
};

exports.QuestionMark = QuestionMark;